import { Component, Inject, OnInit } from '@angular/core';
import NiboWhatsAppConnection from '../../models/nibo-whatsapp-connection';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-connection-confirm-restart',
  templateUrl: './connection-confirm-restart.component.html',
  styleUrls: ['./connection-confirm-restart.component.css']
})
export class ConnectionConfirmRestartComponent implements OnInit {

   public updateData: { connection: NiboWhatsAppConnection };

   constructor(@Inject(MAT_DIALOG_DATA) public data: { connection: NiboWhatsAppConnection },
     public dialogRef: MatDialogRef<ConnectionConfirmRestartComponent>) {
     this.updateData = data;
   }

   ngOnInit(): void {
   }

   public confirm() {
     this.dialogRef.close(true);
   }

   public cancel() {
     this.dialogRef.close(false);
   }

}
